import { intl } from "LocaleWrapper";
import { Box, IconButton, useTheme } from "@mui/material";
import ForumIcon from "@mui/icons-material/Forum";
import CloseIcon from "@mui/icons-material/Close";

const CommentsWidgetHeader = ({ onClose }: { onClose: () => void; }) => {
	const theme = useTheme();
	return (
		<Box
			sx={{
				alignItems: "center",
				backgroundColor: theme.palette.mode === "dark" ? "primary.main" : "#072035",
				boxSizing: "border-box",
				color: "#FFF",
				display: "flex",
				height: 48,
				fontSize: 16,
				fontWeight: 600,
				justifyContent: "space-between",
				px: 2,
				width: "100%",
			}}>
			<Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
				<ForumIcon sx={{ fontSize: 20, opacity: 0.9 }} />
				{intl.formatMessage({ id: "COMMENTS" })}
			</Box>

			<IconButton
				onClick={() => onClose()}
				size="small"
				sx={{
					color: "#FFF",
					backgroundColor: "rgba(255, 255, 255, 0.1)",
					"&:hover": {
						backgroundColor: "rgba(255, 255, 255, 0.2)",
					},
					transition: "all 0.2s",
				}}>
				<CloseIcon fontSize="small" />
			</IconButton>
		</Box>
	);
};

export default CommentsWidgetHeader;
